/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from "classnames";
import Button from "components/Buttons/ThemeButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Fragment } from "react";
import { getFlexBasis } from "../helper";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";
import { selectDipState } from "redux/slices";
import { useAppSelector, useImagePath } from "hooks";
import { getClassNameVariant } from "components/DIP/helper";
import { useDIPAction } from "components/DIP/hooks";
import {
	Container,
	BogoItem,
	OffersContainer,
	ItemImage,
	RewardsContainer,
	RewardItem,
	RewardAmount,
	Footer,
	LoyaltyPoints,
	OfferItem,
	Plus,
	FreeTag,
	Multiplier,
	CrossedOutValue,
	ImageContainer,
	CustomLoyaltyPointsV2
} from "./styles";
import { FeaturesFlags } from "helpers";
import { CrossedOutText, LoyaltyPointsV2 } from "styles/general_styles";
import { useEnvContext } from "contexts";
import bgMultiplier from "assets/bg-multiplier.png";
import { useDIPRewardsV2 } from "components/DIP/hooks/useDIPRewardsV2";
import { sortBundleRewards } from "helpers/rewardSort";

interface BogoProps {}

export const Bogo: React.FC<BogoProps> = () => {
	const { currentDip, claimRewardProcess } = useAppSelector(selectDipState);
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty messaging.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	const { isFeatureFlagEnabled } = useEnvContext();
	const { onAction } = useDIPAction();
	const { loading } = claimRewardProcess;
	const { getImage } = useImagePath("local");
	const plus = getImage("/spec_dips/bogo_plus.png");
	const freeTag = getImage("/spec_dips/free_tag.png");
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const isMobile = isPortrait;
	const {
		rewards,
		loyaltyPointReward,
		rewardMultiplier,
		price,
		loyaltyPointCrossout
	} = useDIPRewardsV2(currentDip?.buttons?.[0]);

	if (!currentDip || !currentDip.buttons) {
		return <Fragment />;
	}

	const { buttons } = currentDip;
	const data = [buttons[0], buttons[0]];

	return (
		<Container id="bd-container">
			<OffersContainer
				id="bd-offers-container"
				className={getClassNameVariant(data?.length as number)}
			>
				{data?.map((item, index) => {
					const bogoOffer =
						index + 1 === data.length &&
						typeof rewardMultiplier !== "undefined";
					return (
						<BogoItem id="bd-bogo-item" key={`${item.id} ${index}`}>
							<OfferItem
								id="bd-offer-item"
								className={classNames([
									getClassNameVariant(data.length as number),
									"item-reward"
								])}
							>
								<RewardsContainer
									className={classNames([
										getClassNameVariant(data.length as number),
										"bundle-rewards-item"
									])}
								>
									{sortBundleRewards(rewards).map(
										({ imageUrl, description }, key) => {
											const flexBasis = getFlexBasis(data, rewards, isMobile);

											const rewardAmount = bogoOffer
												? (
														Number(description?.replace(",", "")) *
														(rewardMultiplier || 0)
												  ).toLocaleString("en-US")
												: description;

											return (
												<RewardItem key={key} width={flexBasis + "%"}>
													<ImageContainer>
														<ItemImage
															className="item-icon"
															src={imageUrl}
															alt=""
														/>
														{bogoOffer && rewardMultiplier > 1 && (
															<Multiplier image={bgMultiplier}>
																<div>
																	<span>x</span>
																	{rewardMultiplier}
																</div>
															</Multiplier>
														)}
													</ImageContainer>
													{bogoOffer && rewardMultiplier > 1 && (
														<CrossedOutValue>{description}</CrossedOutValue>
													)}

													<RewardAmount className="description">
														{rewardAmount}
													</RewardAmount>
												</RewardItem>
											);
										}
									)}
									{/* {arrayTest.map(({}, key) => {
										const flexBasis = getFlexBasis(data, arrayTest, isMobile);

										return (
											<RewardItem key={key} width={flexBasis + "%"}>
												<ImageContainer>
													<ItemImage
														className="item-icon"
														src={
															"https://cdn.solitairetripeaks.com/WebStore/reward_images/coin.png"
														}https://cdn-a1.tripeaksapp.com
													></ItemImage>
													<Multiplier image={bgMultiplier}>
														<div>
															<span>x</span>
															{3}
														</div>
													</Multiplier>
												</ImageContainer>
												<CrossOutValue>222</CrossOutValue>
												<RewardAmount className="description">
													{333}
												</RewardAmount>
											</RewardItem>
										);
									})} */}
								</RewardsContainer>

								<Footer
									className={classNames([
										loyaltyPointReward && "loyalty-reward",
										getClassNameVariant(data.length as number)
									])}
								>
									{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
										<CustomLoyaltyPointsV2>
											{loyaltyPointCrossout && (
												<CrossedOutText>
													Earn <CrownIconV2 height={"0.9em"} width={"auto"} />
													{bogoOffer
														? (
																(loyaltyPointCrossout || 0) *
																(rewardMultiplier || 0)
														  ).toLocaleString("en-US")
														: loyaltyPointCrossout?.toLocaleString("en-US")}
												</CrossedOutText>
											)}
											<div>
												Earn <CrownIconV2 height="1em" width="auto" />
												{bogoOffer
													? (
															(loyaltyPointReward || 0) *
															(rewardMultiplier || 0)
													  ).toLocaleString("en-US")
													: loyaltyPointReward?.toLocaleString("en-US")}
											</div>
										</CustomLoyaltyPointsV2>
									) : (
										<LoyaltyPoints>
											<div>
												Earn <CrownIcon width={16} />
												{bogoOffer
													? (
															(loyaltyPointReward || 0) *
															(rewardMultiplier || 0)
													  ).toLocaleString("en-US")
													: loyaltyPointReward?.toLocaleString("en-US")}
											</div>
										</LoyaltyPoints>
									)}
									{/*
										{isPoisActive && (
											<PoisBountyLabel>
												Contribute to Poi’s Bounty
											</PoisBountyLabel>
										)}
									*/}
								</Footer>
								{bogoOffer && <FreeTag src={freeTag} />}
							</OfferItem>
							{!bogoOffer && <Plus src={plus} />}
						</BogoItem>
					);
				})}
			</OffersContainer>
			<Button
				className="bogo-button"
				style={{ marginTop: isMobile ? "0.5em" : "0.4em" }}
				disabled={loading}
				onClick={() => onAction(data[0], price)}
			>
				{price} USD
			</Button>
		</Container>
	);
};
